import { render, staticRenderFns } from "./McmInfoIcon.vue?vue&type=template&id=95d63af2&scoped=true"
import script from "./McmInfoIcon.vue?vue&type=script&lang=ts"
export * from "./McmInfoIcon.vue?vue&type=script&lang=ts"
import style0 from "./McmInfoIcon.vue?vue&type=style&index=0&id=95d63af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d63af2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
